import {useAppSelector} from '@/hooks';

export function useFullySelectedGroupId(pageId?: string): string | null {
  return useAppSelector((state) => {
    const pageHashedId = pageId ?? state.posterEditor.currentPageId;
    if (!pageHashedId) {
      return null;
    }
    const ids = state.posterEditor.activeItemIds[pageHashedId];
    const itemsHashMap = state.posterEditor.posterObject?.pages.pagesHashMap[pageHashedId]?.items.itemsHashMap;
    if (!ids || !itemsHashMap) {
      return null;
    }
    const selectedItems = ids.map((id) => itemsHashMap[id]).filter((item) => item !== undefined);
    if (selectedItems.length < 2) {
      return null;
    }
    const firstGroupId = selectedItems[0].groupId;
    if (!firstGroupId) {
      return null;
    }
    if (!selectedItems.every((item) => item.groupId === firstGroupId)) {
      return null;
    }
    let memberCount = 0;
    for (const item of Object.values(itemsHashMap)) {
      if (item.groupId === firstGroupId) {
        memberCount = memberCount + 1;
      }
    }
    if (selectedItems.length !== memberCount) {
      return null;
    }
    return firstGroupId;
  });
}
